import React, { Component } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Loading from "../../components/Loading";
import PDFViewer from "../../components/PDFViewer";
import ProtectedRoute from "../../components/ProtectedRoute";
import URL from "../../config/api";
import axios from "../../config/axios";
import { caminhoDoLo, loDaResposta } from "../../utils/loSingleView";

class PDFPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      url: null,
      canPrint: false,
      currentPage: null,
      // totalPages: null,
      pageAnnotations: [],
      lms: null,
      initialPage: 1
    };
  }

  componentDidMount() {
    const query = new URLSearchParams(window.location.search);
    const url = query.get("url");
    const id = query.get("id");
    const activityId = query.get("activityId");
    const itemId = query.get("itemId");

    if (url) {
      this.setState({
        loading: false,
        url,
        canPrint: true
      });
    } else {
      axios
        .post(
          `${URL.api}content/los/execution/list`,
          { user_id: this.props.user.user.id, lo_id: id },
          { headers: { Authorization: `Bearer${this.props.user.token}` } }
        )
        .then(resp => {
          if (resp.data.success) {
            const jsonObject = JSON.parse(
              (resp.data.data.length > 0 && resp.data.data[0].json) || "{}"
            );
            const initialPage = jsonObject.pageNumber || 1;
            const pageAnnotations = jsonObject.pageAnnotations || [];

            axios
              .get(`${URL.api}content/los/singleView/${id}`, {
                headers: { Authorization: `Bearer${this.props.user.token}` }
              })
              .then(resp => {
                if (resp.data.success) {
                  this.setState({
                    loading: false,
                    url: caminhoDoLo(resp),
                    canPrint: loDaResposta(resp).printable,
                    initialPage,
                    pageAnnotations
                  });
                }
              });

            const startDate = new Date();
            const body = {
              user_id: this.props.user.user.id,
              lo_id: id,
              start: `${startDate.getFullYear()}-${
                startDate.getMonth() + 1
              }-${startDate.getDate()} ${startDate.getHours()}:${startDate.getMinutes()}:${startDate.getSeconds()}`,
              end: `${startDate.getFullYear()}-${
                startDate.getMonth() + 1
              }-${startDate.getDate()} ${startDate.getHours()}:${startDate.getMinutes()}:${startDate.getSeconds()}`,
              json: JSON.stringify({
                pageNumber: initialPage,
                pageAnnotations
              }),
              activity_id: activityId
            };

            axios
              .post(`${URL.api}content/los/execution/insert`, body, {
                headers: { Authorization: `Bearer${this.props.user.token}` }
              })
              .then(resp => {
                if (resp.data.success) {
                  this.setState({ lms: resp.data.data });
                }
              });
          }
        });
    }
  }

  pageChanged(obj) {
    this.setState(
      {
        currentPage: obj.pageNumber,
        // totalPages: obj.numPages,
        pageAnnotations: obj.pageAnnotations
      },
      () => {
        if (!this.state.lms) {
          return;
        }

        const updateJson = () => {
          const tempDate = new Date();
          const body = {
            end: `${tempDate.getFullYear()}-${
              tempDate.getMonth() + 1
            }-${tempDate.getDate()} ${tempDate.getHours()}:${tempDate.getMinutes()}:${tempDate.getSeconds()}`,
            json: JSON.stringify({
              pageNumber: obj.pageNumber,
              pageAnnotations: obj.pageAnnotations
            })
          };

          if (this.state.lms) {
            axios.post(
              `${URL.api}content/los/execution/update/${this.state.lms}`,
              body,
              { headers: { Authorization: `Bearer${this.props.user.token}` } }
            );
          }
        };

        if (obj.force) {
          updateJson();
        } else {
          setTimeout(() => {
            if (
              this.state.lms &&
              obj.pageNumber === this.state.currentPage &&
              obj.numPages
            ) {
              updateJson();
            }
          }, 5000);
        }
      }
    );
  }

  componentWillUnmount() {
    if (!this.state.lms) {
      return;
    }

    const tempDate = new Date();
    const body = {
      end: `${tempDate.getFullYear()}-${
        tempDate.getMonth() + 1
      }-${tempDate.getDate()} ${tempDate.getHours()}:${tempDate.getMinutes()}:${tempDate.getSeconds()}`,
      json: JSON.stringify({
        pageNumber: this.state.currentPage,
        pageAnnotations: this.state.pageAnnotations
      })
    };

    axios.post(
      `${URL.api}content/los/execution/update/${this.state.lms}`,
      body,
      { headers: { Authorization: `Bearer${this.props.user.token}` } }
    );
  }

  render() {
    /* Print, Download, numeração da última página e JSON do FabricJS */
    const readedPages = [];

    return (
      <div
        style={{
          width: "100vw",
          minHeight: "100vh",
          backgroundColor: "rgb(121, 122, 125)"
        }}
        className="h-100 d-flex align-items-center justify-content-center"
      >
        {this.state.loading ? (
          <Loading />
        ) : (
          <PDFViewer
            src={this.state.url}
            enablePrint={this.state.canPrint}
            enableSave={this.state.canPrint}
            lastPageOpened={this.state.initialPage}
            documentJSON={
              this.state.pageAnnotations[this.state.initialPage] ||
              '{"version":"4.5.1","objects":[]}'
            }
            pageAnnotations={this.state.pageAnnotations}
            readedPages={readedPages}
            onChange={e => this.pageChanged(e)}
          />
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

PDFPage.propTypes = {
  hideLayout: PropTypes.bool,
  guestLogin: PropTypes.bool
};

PDFPage.defaultProps = {
  hideLayout: true,
  guestLogin: true
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  socket: state.socket
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PDFPage);
